export default "__VITE_ASSET__D7ng6fxt__"